// extracted by css-extract-rspack-plugin
export default {"ButtonRoot":"q68q1","isSelected":"YHdfA"};